import { DroppedPromise } from '../../../components/file-uploader/types';

const createDroppedPromise = <T>(): DroppedPromise<T> => {
  let resolve;
  let reject;
  const promise = new Promise<T>((res, rej) => {
    resolve = res;
    reject = rej;
  });

  return {
    promise,
    resolve,
    reject,
  };
};

export default createDroppedPromise;
